import { observer } from 'mobx-react';
import * as React from 'react';
import { ExperienceResource } from '../../../../../../Types';
import LearningCollectionEditStore from '../../../../Store';
import { ModifiableExperiencesContext } from '../../../../../Types';
import ExperienceRowItems from '../Experiences/ExperienceRowItems';
import ExperienceRowItemsWithHandlers from './ExperienceRowItemsWithHandlers';

interface Props {
  context: ModifiableExperiencesContext;
  experienceResource: ExperienceResource;
  learningCollectionStore: LearningCollectionEditStore;
}

const CustomizeRow: React.FC<Props> = ({
  context,
  experienceResource,
  learningCollectionStore,
}) => {
  switch (context.kind) {
    case 'section-context':
      switch (context.section.resource.payload.learningDesignState) {
        case 'curated':
          return <ExperienceRowItems experienceResource={experienceResource} />;
        case 'curated-custom':
        case 'custom':
        case 'blank':
        case 'build-your-own':
        case 'browse-all':
          return (
            <ExperienceRowItemsWithHandlers
              context={context}
              store={learningCollectionStore}
              experienceResource={experienceResource}
            />
          );
        case 'empty':
          return <></>;
      }
    case 'browse-all-experiences':
      return (
        <ExperienceRowItemsWithHandlers
          context={context}
          store={learningCollectionStore}
          experienceResource={experienceResource}
        />
      );
  }
};

export default observer(CustomizeRow);
